import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "row mb-1" };
const _hoisted_2 = { class: "col-6 text-truncate" };
const _hoisted_3 = { class: "col-6" };
const _hoisted_4 = { class: "flex-fill text-end fw-bold" };
const _hoisted_5 = {
    key: 0,
    class: "text-danger"
};
const _hoisted_6 = /*#__PURE__*/ _createTextVNode(" Ja ");
const _hoisted_7 = /*#__PURE__*/ _createTextVNode(" Nein ");
const _hoisted_8 = /*#__PURE__*/ _createTextVNode(" Ja ");
const _hoisted_9 = /*#__PURE__*/ _createTextVNode(" Nein ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.caption), 1),
        _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.fields, (tField) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: tField.member,
                    class: "d-flex flex-row"
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        (tField.validation?.state !== 'succeeded')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(tField.validation?.message), 1))
                            : (_ctx.element.dataType === 'string')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.data[tField.member]), 1)
                                ], 64))
                                : (_ctx.element.dataType === 'date')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$utils.formatDate(Date.parse(_ctx.data[tField.member]), 'date')), 1)
                                    ], 64))
                                    : (_ctx.element.dataType === 'integer')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createTextVNode(_toDisplayString(_ctx.data[tField.member]), 1)
                                        ], 64))
                                        : (_ctx.element.dataType === 'decimal' || _ctx.element.dataType === 'money')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                _createTextVNode(_toDisplayString(_ctx.$utils.formatNumberWithDcp(_ctx.data[tField.member], _ctx.element.config?.decimalPlaces ?? 0)), 1)
                                            ], 64))
                                            : (_ctx.element.dataType === 'bool')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                    (_ctx.data[tField.member])
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _hoisted_6
                                                        ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _hoisted_7
                                                        ], 64))
                                                ], 64))
                                                : (_ctx.element.dataType === 'check')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                        (_ctx.data[tField.member])
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _hoisted_8
                                                            ], 64))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _hoisted_9
                                                            ], 64))
                                                    ], 64))
                                                    : _createCommentVNode("", true)
                    ])
                ]));
            }), 128))
        ])
    ]));
}
